import { render, staticRenderFns } from "./VsCollapseItemM.vue?vue&type=template&id=36918ad4"
import script from "./VsCollapseItemM.vue?vue&type=script&lang=js"
export * from "./VsCollapseItemM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports